<template>
    <div class="personal-photo">
        <module-title title="证件照"></module-title>
        <div class="photo-upload-tips-box">
            <div class="photo-upload-tips">
                <div
                    class="photo-upload"
                    @mouseover="showTips = true"
                    @mouseleave="mouseleaveImg"
                >
                    <el-upload
                        class="photo-uploader"
                        accept="image/png,image/jpg,image/jpeg"
                        action="#"
                        :http-request="changPhoto"
                        :show-file-list="false"
                        :disabled="disabled"
                    >
                        <img
                            :src="photoSrc"
                            alt="二寸照片"
                            class="photo"
                            v-if="hasPhoto"
                        />
                        <div class="upload-tips-text" v-if="showTips">
                            <i class="el-icon-upload"></i>
                            <div class="">{{ uploadTipsText }}</div>
                        </div>
                    </el-upload>
                </div>
                <div class="photo-tips">
                    <div class="attention-text">
                        <p>上传二寸照注意事项</p>
                        <span>
                            上传电子版照片为您本人近期免冠小二寸证件照，蓝底，照片像素不小于390*530，文件格式为jpg格式，大小不得超过5MB。
                        </span>
                        <el-button type="warning" size="small " @click="savePhoto"
                            :disabled="disabled"
                            >保存</el-button
                        >
                        <em>此照片用于制作证书，请按以上要求上传。</em>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";
import { PcCookie, Key } from "@/utils/cookie";
import { getUserNews } from "@/api/personal";
import { editPhoto } from "api/personal"
export default {
    components: { ModuleTitle },
    computed: {
        uploadTipsText() {
            let txt = this.hasPhoto ? "修改二寸照片" : "上传二寸照片";
            return txt;
        },
    },
    data() {
        return {
            changeImg: false,
            hasPhoto: false,
            showTips: true,
            photoSrc: "",
            disabled: false,
        };
    },
    created(){
        this.fetchUserNews();
    },
    methods: {
        //获取用户信息
        fetchUserNews() {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getUserNews(sessionId).then((res) => {
                if (res.errorCode === "2000") {
                    this.photoSrc = res.body.data.certificate1 ? res.body.data.certificate1 : '';
                    this.showTips = res.body.data.certificate1 ? false : true;
                    this.hasPhoto = res.body.data.certificate1 ? true : false;
                }
            });
        },
        //保存一寸照
        savePhoto(){
            this.disabled = true;
            const sessionId = PcCookie.get(Key.jsessIdKey);
            editPhoto(sessionId,this.photoSrc).then(res => {
                const { success, msg } = res
                if(success){
                    this.$message({
                        type: 'success',
                        message: msg
                    })
                }else{
                    this.$message({
                        type: 'warning',
                        message: msg
                    })
                }
                this.disabled = false;
            })
        },
        mouseleaveImg() {
            if (this.changeImg) {
                this.showTips = false;
            }
        },
        changPhoto(data) {
            let that = this;
            let rd = new FileReader();
            let file = data.file;
            rd.readAsDataURL(file);
            rd.onloadend = function () {
                var img = document.createElement("img");
                img.src = this.result;
                img.onload = function () {
                    const isLt5M = file.size / 1024 / 1024  < 5 ;
                    let imgWidth = img.width;
                    let imgHeight = img.height;
                    if(imgWidth < 390 || imgHeight < 530){
                        that.$message({
                            type: 'warning',
                            message: '请上传规定宽高之内的图片'
                        })
                    }else if(!isLt5M) {
                        that.$message({
                            type: 'warning',
                            message: '上传图片不能超过5MB'
                        })
                    }else{
                        that.photoSrc = img.src;
                        that.hasPhoto = true;
                        that.showTips = false;
                    }
                }
            };
        },
    },
    watch: {
        photoSrc(newSrc) {
            if (newSrc) {
                this.changeImg = true;
            }
        },
    },
};
</script>

<style>
.personal-photo .el-icon-upload {
    font-size: 67px;
    color: #c0c4cc;
    margin: 0 0 16px;
    line-height: 50px;
}
.personal-photo .el-upload--text {
    height: 100%;
    width: 100%;
}
.personal-photo .photo-uploader {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
.personal-photo .photo-uploader img {
    width: 100%;
    height: 100%;
}
</style>

<style lang="less" scoped>
.attention-text {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    >p{
        line-height: 48px;
        font-size: 16px;
        color: #ef0c0c;
    }
    >span{
        line-height: 28px;
        font-size: 14px;
        color: #505050;
        width: 76%;
    }
    button{
        margin: 20px 0;
        width: 120px;
    }
    >em{
        line-height: 28px;
        font-size: 14px;
        font-style: normal;
        color: #ef0c0c;
        text-align: center;
        width: 76%;
    }
}
.photo {
    width: 100%;
    height: 100%;
}
.upload-tips-text {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
    font-size: 16px;
    font-weight: bold;
    color: #c0c4cc;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.photo-tips {
    margin-left: 20px;
    flex: 1;
}
.photo-upload {
    width: 200px;
    height: 100%;
}
.photo-upload-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 120px;
    width: 860px;
    height: 265px;
    border: solid 1px #ededed;
}
.photo-upload-tips-box {
    flex: 1;
    display: flex;
    justify-content: center;
}
.personal-photo {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
